import React, { useState, Fragment, useEffect } from 'react';
import axios from 'axios'
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    NavLink,
    Alert
} from 'reactstrap'
import { Redirect } from 'react-router-dom'

import Qworky_Banner from '../assets/img/Qworky_Banner.jpg'
import UpdateLandingPhoto from '../components/SiteAdmin/UpdateLandingPhoto';


const SiteAdmin = props => {
    const [modal, setModal] = useState(false)

    const toggle = () => setModal(!modal)

    const [adminDetails, setAdminDetails] = useState(null)

    async function loadImages() {
        try {
            const { data } = await axios.get('/api/site-admin')
            setAdminDetails(data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        loadImages()
    }, [])

    return (
        <Fragment>
            <UpdateLandingPhoto
                modal={modal}
                toggle={toggle}
                adminDetails={adminDetails}
                loadImages={loadImages}
            />
            <Card
                style={{ maxWidth: '1080px', width: '80%', margin: 'auto', marginTop: '20px' }}
            >
                <CardHeader
                >
                    Site Admin
                </CardHeader>
                <CardBody>
                    <div style={{ width: "50%", margin: 'auto', position: 'relative' }}>
                        <img
                            style={{ width: "100%" }}
                            src={adminDetails?.landingPage ? adminDetails.landingPage : Qworky_Banner}
                        />
                        <Button style={{ position: 'absolute', left: "0" }}
                            onClick={toggle}
                        >Update Photo</Button>
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default SiteAdmin